import { useEffect, useState } from 'react';
import { OnlineProduct } from '@jbhi-fi/apis/src/shopify/types/OnlineProduct';
import { ShopifyProduct } from '@jbhi-fi/components/src/Shopify/types';
import { getStoreCurrency } from '../../../../utils/shopify/getStoreCurrency';

export const sendInsiderObject = (metafields: OnlineProduct, shopify: ShopifyProduct) => {
  if (!window?.insider_object || window.insider_object?.product?.id === metafields.Id) return;

  window.insider_object.product = {
    id: metafields.Id,
    name: metafields.Display.OnlineDescription ?? '',
    taxonomy: metafields.Display.CategoryHierarchy ?? [],
    currency: getStoreCurrency(),
    unit_price: metafields.Price.CoreTicketPrice,
    unit_sale_price: metafields.Price.DisplayPriceInc,
    url: `/products/${shopify.handle}`,
    color: metafields.Family?.Options?.find(option => option.Name === 'Colour')?.Children?.find(
      child => child.SKU === metafields.Id
    )?.Value,
    size: metafields.Family?.Options?.find(option =>
      ['Storage Type', 'Apparel size'].includes(option.Name)
    )?.Children?.find(child => child.SKU === metafields.Id)?.Value,
    product_image_url: shopify.images[0],
  };
  window?.Insider?.eventManager?.dispatch('init-manager:re-initialize');
};

export const useInsiderObject = () => {
  const [insiderObject, setInsiderObject] = useState<any>(undefined);
  const [hasLoaded, setHasLoaded] = useState(false);

  const reInitializeInsiderObject = () => window?.Insider?.eventManager?.dispatch('init-manager:re-initialize');

  useEffect(() => {
    function checkForInsiderObject() {
      if (window.insider_object) {
        setInsiderObject(window.insider_object);
        setHasLoaded(true);
        return;
      }

      setTimeout(checkForInsiderObject, 100);
    }

    checkForInsiderObject();
  }, []);

  return { insiderObject, hasLoaded, reInitializeInsiderObject };
};
